import main from "../view/main";
import login from "../view/access/login";
import register from "../view/access/register";
import workbench from "../view/workbench";

import tools from "./tools";
import mail from "./mail";

import jofph from "./jofph";

//按模块拆分路由

const Routers = [tools, mail];

Routers.push(...jofph);

const MainRouter = {
  path: "/main",
  component: main,
  redirect: "/workbench",
  name: "主页",
  children: [
    {
      //工作台
      path: "/workbench",
      component: workbench,
      name: "工作台",
    },
  ],
};

//拼接路由
Routers.map((route) => {
  route.map((item) => {
    MainRouter.children.push(item);
  });
});

//渲染路由
export const routers = [
  {
    path: "",
    redirect: "/access/login",
  },
  MainRouter,
  //用户登录路由
  {
    path: "/access",
    component: login,
    redirect: "/access/login",
    meta: { noCheckSession: true },
    children: [
      {
        path: "/access/login",
        component: login,
        meta: { noCheckSession: true },
      },
    ],
  },
  {
    path: "/access/register",
    component: register,
    meta: { noCheckSession: true },
  },
  {
    path: "*",
    redirect: "/main",
  },
];
